import { useEffect, useState } from 'react';

interface TimerProps {
  seconds: number;
  onExpire?: () => void;
}

export const Timer = ({ seconds, onExpire }: TimerProps) => {
  const [time, setTime] = useState(seconds);

  useEffect(() => {
    setTime(seconds);
  }, [seconds]);

  useEffect(() => {
    if (time <= 0) {
      onExpire?.();
      return;
    }

    const interval = setInterval(() => {
      setTime((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onExpire?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [time, onExpire]);

  const isLowTime = time <= 5;
  const minutes = Math.floor(time / 60);
  const secs = time % 60;

  return (
    <div className={`text-2xl font-bold ${isLowTime ? 'text-red-600' : 'text-gray-700'}`}>
      {String(minutes).padStart(2, '0')}:{String(secs).padStart(2, '0')}
    </div>
  );
};
